import { render, staticRenderFns } from "./menu-list.component.vue?vue&type=template&id=5c46c904"
import script from "./menu-list.component.vue?vue&type=script&lang=js"
export * from "./menu-list.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports